export const APP_VERSION = '1.19.0';
